<template>
  <transition name="fade">
    <div class="toast" v-if="show">复制成功</div>
  </transition>
</template>

<script>
export default {
  props: ['show'],
  watch: {
    show(v) {
      if (v) {
        setTimeout(() => {
          this.$emit('update:show', false);
        }, 1000);
      }
    },
  },
};
</script>

<style scoped lang="less">
.toast {
  background: rgba(57, 61, 64, 0.9);
  backdrop-filter: blur(12.5px);
  border-radius: 17px;
  width: 92px;
  height: 34px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 90px;
  font-weight: 400;
  font-size: 13px;
  text-align: center;
  color: #ffffff;
  text-align: center;
  line-height: 34px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s cubic-bezier(0, 0, 0.58, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
